import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export const TYPE = {
  TERMS: 1,
  CREATIVE: 2,
  PUBLISHER: 3,
  CUSTOM_CREATIVE: 4,
};

export const GLIMMER_LEGAL_TYPES = {
  [TYPE.TERMS]: "Terms of Service",
  [TYPE.CREATIVE]: "ICSA",
  [TYPE.PUBLISHER]: "Master Publisher Agreement",
};

export default ShModel.extend({
  content: attr('string'),
  createdAt: attr('date'),
  isAccepted: attr('boolean'),
  isDefault: attr('boolean'),
  title: attr('string'),
  type: attr('number'),
  updatedAt: attr('date'),

  company: belongsTo('company', { async: false }),
});
